import ContextMenu from './ContextMenu.js';

export default class LayerSectionBase {
  constructor(elSection, selection, requestDraw, contextMenuDefs) {
    this._selection = selection;
    this._requestDraw = requestDraw;

    //-- レイヤー表示リスト関連
    this._elSection = elSection;
    this._elDisplayTemplate = elSection.querySelector('.displayTemplates .display');
    this._elDisplayList = elSection.querySelector('.displayList');
    this._elMoveBar = elSection.querySelector('.moveBar');
    this._draggedDummy = null;
    this._hideOptionsTimeoutID = 0;

    this._getArrElDisplay().forEach(v => this._initDisplay(v));
    
    window.addEventListener('mousemove', e => this._updateDragging(e));
    window.addEventListener('mouseup', e => this._finishDragging(e));

    //-- コンテキストメニュー
    this._contextMenu = new ContextMenu(contextMenuDefs);
    this._elDisplayList.addEventListener('contextmenu', e => this._onDisplayListContextMenu(e));
  }

  get elSection() {
    return this._elSection;
  }
  get elContextMenu() {
    return this._contextMenu.elList;
  }

  //--- 要継承
  _selectInnerData(idx) {
  }
  _drawThumbnail(canvas, idx) {
  }
  _doMove(srcIdx, srcSz, dstIdx) {
  }

  //--- 表示／非表示を切り替え
  show(yes) {
    if(yes) {
      this._elSection.classList.remove('hidden');
    } else {
      this._elSection.classList.add('hidden');
    }
  }
  
  //--- レイヤー表示をリストに追加
  _addDisplays(idx, sz, show = true) {
    const elDst = this._getElDisplayFromIdx(idx);
    for(let i = 0; i < sz; ++i) {
      const elNew = this._elDisplayTemplate.cloneNode(true);
      if(show) elNew.classList.add('show');
      this._initDisplay(elNew);
      this._elDisplayList.insertBefore(elNew, elDst);
    }
  }
  
  //--- レイヤー表示を削除
  _deleteDisplays(idx, sz) {
    const arrElDisplay = this._getArrElDisplayFromIdx(idx, sz);
    arrElDisplay.forEach(v => v.addDeleteFlag());
  }
  _deleteDisplaysRightNow(idx, sz) {
    const arr = this._getArrElDisplay();
    for(let i = 0; i < sz; ++i) arr[idx + i].remove();
  }
  
  //--- レイヤー表示を移動　dstIdxはレイヤー表示サイズをとりうる
  _moveDisplays(srcIdx, srcSz, dstIdx) {
    const arrElSrc = this._getArrElDisplayFromIdx(srcIdx, srcSz);
    const elDst = this._getElDisplayFromIdx(dstIdx);
  
    //-- first-childの入れ替わりに際しmargin-topをアニメーションで変化させる
    {
      const selector = LayerSectionBase._ACTIVE_DISPLAY_SELECTOR;
      const firstChild = this._elDisplayList.querySelector(selector + ':first-child');
      if(elDst === firstChild) {
        elDst.classList.add('prevTop');
      } else if(arrElSrc[0] === firstChild) {
        arrElSrc.at(-1).nextElementSibling?.classList.add('nextTop');
      }
    }
  
    //-- 移動元のレイヤー表示を移動先にクローンして削除フラグを立てる
    arrElSrc.forEach(elSrc => {
      const newDisplay = elSrc.cloneNode(true);
      newDisplay.querySelector('canvas').getContext('2d').drawImage(elSrc.querySelector('canvas'), 0, 0);
      newDisplay.classList.remove('draggedSrc');
      this._elDisplayList.insertBefore(newDisplay, elDst);
      this._initDisplay(newDisplay);
      newDisplay.classList.add('show');
      elSrc.addDeleteFlag();
    });
  }
  
  //--- レイヤー表示の選択状態を更新
  _selectDisplay(elDisplay) {
    this._getArrElDisplay().forEach(v => {
      if(v === elDisplay) {
        v.classList.add('selected');
      } else {
        v.classList.remove('selected');
      }
      v.classList.remove('mulSelected');
    });
  }
  _mulSelectDisplay(elFrom, elTo) {
    let flag = false;
    this._getArrElDisplay().forEach(v => {
      const isTurningPoint = v === elFrom || v === elTo;
      if(isTurningPoint) flag = !flag;
      if(flag || isTurningPoint) {
        v.classList.add('mulSelected');
      } else {
        v.classList.remove('mulSelected');
      }
    });
  }
  _select(elFrom, elTo) {
    this._selection.finishIfNot();
    const prevSelected = this._getElDisplaySelected();
    this._selectDisplay(elFrom);
    if(elFrom !== elTo) this._mulSelectDisplay(elFrom, elTo);
    this._selectInnerData(this._getDisplayIdxFromElem(elFrom));
    //if(prevSelected) this._updateThumbnail(prevSelected);
    this._requestDraw();
  }
  select(idx, sz = 1) {
    const elFrom = this._getElDisplayFromIdx(idx);
    const elTo = this._getElDisplayFromIdx(idx + sz - 1);
    this._select(elFrom, elTo);
  }
  select2(idx) {
    const sz = this.getDisplaySz();
    this.select(Math.max(0, Math.min(idx, sz - 1)));
  }
  selectIfNot(idx) {
    const elDisplay = this._getElDisplayFromIdx(idx);
    if(!elDisplay.classList.contains('selected')) this.select(idx);
  }

  //--- 削除中でないレイヤー表示をHTML要素で取得
  static get _ACTIVE_DISPLAY_SELECTOR() {
    return '.display:not(.delete)';
  }
  _getElDisplayFromIdx(idx) {
    return this._getArrElDisplay()[idx];
  }
  _getElDisplaySelected() {
    const selector = LayerSectionBase._ACTIVE_DISPLAY_SELECTOR;
    return this._elDisplayList.querySelector(`${selector}.selected`);
  }
  _getArrElDisplay() {
    const selector = LayerSectionBase._ACTIVE_DISPLAY_SELECTOR;
    return this._elDisplayList.querySelectorAll(selector);
  }
  _getArrElDisplayFromIdx(idx, sz) {
    return [...this._getArrElDisplay()].slice(idx, idx + sz);
  }
  _getArrElDisplaySelected() {
    const selector = LayerSectionBase._ACTIVE_DISPLAY_SELECTOR;
    return this._elDisplayList.querySelectorAll(`${selector}.selected, ${selector}.mulSelected`);
  }
  
  //--- レイヤー表示のインデックスを取得
  _getDisplayIdxFromElem(elDisplay) {
    const arrElDisplay = this._getArrElDisplay();
    for(let i = 0; i < arrElDisplay.length; ++i) {
      if(arrElDisplay[i] === elDisplay) {
        return i;
      }
    }
    throw new Error;
  }
  getDisplaySz() {
    const arr = this._getArrElDisplay();
    return arr.length;
  }
  getDisplayIdxSelected() {
    const elDsiplay = this._getElDisplaySelected();
    return this._getDisplayIdxFromElem(elDsiplay);
  }
  _getDisplaySzSelected() {
    const arr = this._getArrElDisplaySelected();
    return arr.length;
  }
  _getDisplayIdxSzSelected() {
    const arr = this._getArrElDisplaySelected();
    return [this._getDisplayIdxFromElem(arr[0]), arr.length];
  }

  //--- レイヤー表示用イベントとその登録
  _initDisplay(elDisplay) {
    elDisplay.addEventListener('animationstart', e => this._onDisplayAnimationStart(e));
    elDisplay.addEventListener('animationend', e => this._onDisplayAnimationEnd(e));
    elDisplay.addEventListener('click', e => this._onDisplayClick(e));
    elDisplay.addEventListener('dragstart', e => this._onDisplayDragStart(e));
    elDisplay.addDeleteFlag = () => {
      elDisplay.classList.add('delete');
      elDisplay.classList.remove('selected');
      elDisplay.classList.remove('mulSelected');
    }
  }
  _onDisplayAnimationStart(e) {
    document.body.classList.add('dontTouchCuzLayerDisplayAnimation');
  }
  _onDisplayAnimationEnd(e) {
    switch(e.animationName) {
    case 'layerSectionShowDisplay':
      e.target.classList.remove('show');
      break;
    case 'layerSectionDeleteDisplay':
      /*
      if(e.target.classList.contains('selected')) {
        label: do {
          for(let next = e.trget.nextElementSibling; next !== null; next = e.trget.nextElementSibling) {
            if(next.classList.contains('delete')) {
              this.select(this._getDisplayIdxFromElem(next));
              break label;
            }
          }
          for(let prev = e.trget.previousElementSibling; prev !== null; prev = e.trget.previousElementSibling) {
            if(prev.classList.contains('delete')) {
              this.select(this._getDisplayIdxFromElem(prev));
              break label;
            }
          }
        } while(false);
      }
      */
      e.target.remove();
      this._requestDraw();
      break;
    case 'layerSectionGrowDisplayMargin':
      e.target.classList.remove('prevTop');
      break;
    case 'layerSectionShrinkDisplayMargin':
      e.target.classList.remove('nextTop');
      break;
    }
    document.body.classList.remove('dontTouchCuzLayerDisplayAnimation');
  }
  _onDisplayClick(e) {
    const elClicked = e.currentTarget;
    const elSelected = this._getElDisplaySelected();
    if(elSelected && (e.shiftKey || e.ctrlKey || e.metaKey)) {
      this._select(elSelected, elClicked);
    } else {
      this._select(elClicked, elClicked);
    }
  }
  _onDisplayDragStart(e) {
    e.preventDefault();
    if(e.button !== 0) return;

    //-- 未選択レイヤー表示がドラッグされた場合、選択する
    if(![...this._getArrElDisplaySelected()].includes(e.target)) {
      this._selectDisplay(e.target);
    }
    
    //-- ドラッグされているレイヤー表示の情報を持つオブジェクトを確保
    // 未使用時はnullで、ドラッグされているレイヤー表示があるか否かのフラグになる
    const dummy = this._draggedDummy = {};
    dummy.scrollId = 0;

    //-- 移動対象の要素を保存
    dummy.arrElSrc = this._getArrElDisplaySelected();
    dummy.srcIdx = this._getDisplayIdxFromElem(dummy.arrElSrc[0]);
    dummy.srcSz = dummy.arrElSrc.length;

    //-- マウスを離したときの移動先を移動元と同じ（つまり移動しない）にセット
    dummy.dstIdx = dummy.srcIdx;
    dummy.moveFlag = false;

    //-- ドラッグ開始時点のレイヤー表示の位置とマウスカーソルとのオフセットを保存
    {
      const displayRect = dummy.arrElSrc[0].getBoundingClientRect();
      dummy.offsetX = e.x - Math.floor(displayRect.x);
      dummy.offsetY = e.y - Math.floor(displayRect.y);
    }

    //-- 移動対象のクローンを入れる入れ物を用意
    dummy.element = document.createElement('div');
    dummy.element.classList.add('draggedDummy');
    dummy.element.style.width = this._elDisplayList.clientWidth  + 'px';
    this._updateDraggedDummyPosition(e);

    //-- 移動対象をクローンして入れ物に入れる
    const frontIdx = this._getDisplayIdxFromElem(dummy.arrElSrc[0]);
    for(let i = 0; i < dummy.arrElSrc.length; ++i) {
      const elSrc = dummy.arrElSrc[i];
      const clone = elSrc.cloneNode(true);
      //this._drawThumbnail(elSrc.querySelector('canvas'), frontIdx + i);
      this._drawThumbnail(clone.querySelector('canvas'), frontIdx + i);
      dummy.element.appendChild(clone);

      //- 元の移動対象は元の位置で透明になる
      elSrc.classList.add('draggedSrc');
    }
    this._elSection.appendChild(dummy.element);

    //-- バブリングを停止してレイヤー表示が選択されないようにする
    e.stopPropagation();
  }
  
  //--- レイヤー表示がドラッグされているとき
  _updateDragging(e) {
    const dummy = this._draggedDummy;
    if(dummy) {
      //-- サムネイルリストの上下外側にカーソルがあれば自動スクロールをオン
      const listRect = this._elDisplayList.getBoundingClientRect();
      if(e.y < listRect.top) {
        if(dummy.scrollId === 0) {
          dummy.scrollId = setInterval(() => {
            this._elDisplayList.scrollTo(0, this._elDisplayList.scrollTop - 1);
          }, 10);
        }
      } else if(listRect.bottom <= e.y) {  // DOMRect.bottomはy+height
        if(dummy.scrollId === 0) {
          dummy.scrollId = setInterval(() => {
            this._elDisplayList.scrollTo(0, this._elDisplayList.scrollTop + 1);
          }, 10);
        }
      } else {
        if(dummy.scrollId !== 0) {
          clearInterval(dummy.scrollId);
          dummy.scrollId = 0;
        }
      }
  
      //-- ダミーレイヤー表示リストを移動
      this._updateDraggedDummyPosition(e);
  
      //-- とりあえず移動なし状態に
      this._elMoveBar.classList.add('hidden');
      dummy.dstIdx = dummy.srcIdx;
  
      //-- スクロール中なら脱出
      if(dummy.scrollId !== 0) return;
  
      //-- レイヤー表示を走査してマウスカーソル位置から未確定の移動状態を求める
      const arrElDisplay = this._getArrElDisplay();
      for(let i = 0; i < arrElDisplay.length; ++i) {
        const elDisplay = arrElDisplay[i];
        const rect = elDisplay.getBoundingClientRect();
        const nextY1 = i + 1 < arrElDisplay.length ?
          arrElDisplay[i + 1].getBoundingClientRect().y : rect.y + rect.height;
  
        if(rect.y <= e.y && e.y < nextY1) {
          const sectionRect = this._elSection.getBoundingClientRect();
          let top;
          if(e.y < rect.y + rect.height / 2) {
            top = (rect.y- sectionRect.y - window.innerHeight*0.02).toFixed() + 'px';
            dummy.dstIdx = i;
          } else {
            top = (rect.bottom- sectionRect.y - window.innerHeight*0.01).toFixed() + 'px';
            dummy.dstIdx = i + 1;
          }
          if(dummy.moveFlag = !(dummy.srcIdx <= dummy.dstIdx && dummy.dstIdx <= dummy.srcIdx + dummy.srcSz)) {
            this._elMoveBar.style.top = top;
            this._elMoveBar.classList.remove('hidden');
            this._elMoveBar.style.width = rect.width.toFixed() + 'px';
            this._elMoveBar.style.left = (rect.x - sectionRect.x).toFixed() + 'px';
          }
          break;
        }
      };
    }
  }
  _updateDraggedDummyPosition(e) {
    const dummy = this._draggedDummy;
    const sectionRect = this._elSection.getBoundingClientRect();
    const x = e.x - sectionRect.x - dummy.offsetX;
    const y = e.y - sectionRect.y - dummy.offsetY;
    dummy.element.style.left = x.toFixed() + 'px';
    dummy.element.style.top = y.toFixed() + 'px';
  }
  
  //--- レイヤー表示のドラッグが離されたとき
  _finishDragging(e) {
    if(e.button !== 0) return;
    const dummy = this._draggedDummy;
    if(dummy) {
      //-- 自動スクロールを解除
      if(dummy.scrollId !== 0) {
        clearInterval(dummy.scrollId);
        dummy.scrollId = 0;
      }
  
      //-- 移動するか、しないなら元に戻す
      if(dummy.moveFlag) {
        this._doMove(dummy.srcIdx, dummy.srcSz, dummy.dstIdx);
      } else {
        dummy.arrElSrc.forEach(elSrc => elSrc.classList.remove('draggedSrc'));
      }

      //-- 後始末
      dummy.element.remove();
      this._draggedDummy = null;
      this._elMoveBar.classList.add('hidden');
    }
  }
  
  //--- レイヤー表示の画像を更新
  updateAllThumbnails() {
    const arrElDisplay = this._getArrElDisplay();
    arrElDisplay.forEach((v, i) => {
      this._drawThumbnail(v.querySelector('canvas'), i);
    });
  }
  _updateThumbnails(idx, sz) {
    const arrElDisplay = this._getArrElDisplay();
    for(let i = 0; i < sz; ++i) {
      this._drawThumbnail(arrElDisplay[idx + i].querySelector('canvas'), idx + i);
    }
  }
  _updateThumbnail(elDisplay) {
    if(elDisplay) {
      this._drawThumbnail(elDisplay.querySelector('canvas'), this._getDisplayIdxFromElem(elDisplay));
    }
  }
  updateSelectedThumbnail() {
    this._updateThumbnail(this._getElDisplaySelected());
  }
  updateThumbnail(idx) {
    const elDisplay = this._getElDisplayFromIdx(idx);
    this._drawThumbnail(elDisplay.querySelector('canvas'), idx);
  }

  //--- コンテキストメニュー
  _onDisplayListContextMenu(e) {
    if(e.target.classList.contains('display')) {
      if(!e.target.classList.contains('selected') && !e.target.classList.contains('mulSelected')) {
        this._selectDisplay(e.target);
      }
      this._contextMenu.show(e.x, e.y);
    } else if(this._getArrElDisplay().length === 0) {
      this._contextMenu.show(e.x, e.y);
    }
  }

  //--- リサイズ監視
  _setResizeObserverX(onResizeX) {
    this._resizeObserverX = new ResizeObserver(entries => {
      const newX = entries[0].target.getBoundingClientRect().x;
      if(this._lastSectionX !== newX) {
        this._lastSectionX = newX;
        onResizeX(newX);
      }
    });
    this._resizeObserverX.observe(this._elSection);
    const x = this._elSection.getBoundingClientRect().x;
    this._lastSectionX = x;
    onResizeX(x);
  }

  //--- 再読み込み
  reset(sz) {
    const currentSz = this.getDisplaySz();
    if(sz < currentSz) {
      this._deleteDisplaysRightNow(0, currentSz - sz);
    } else if(currentSz < sz) {
      this._addDisplays(0, sz - currentSz, false);
    }
    this.select(0);
    this.updateAllThumbnails();
  }
}
